"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireDefault(require("react"));

var _class, _descriptor, _temp;

var DocumentCard = (_class = (_temp =
/*#__PURE__*/
function (_Card$makeDefaultCard) {
  babelHelpers.inherits(DocumentCard, _Card$makeDefaultCard);

  function DocumentCard() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, DocumentCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(DocumentCard)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "fileType", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(DocumentCard, [{
    key: "renderBottomContent",
    value: function renderBottomContent() {
      if (this.isPurchaseTile || this.person) return babelHelpers.get(babelHelpers.getPrototypeOf(DocumentCard.prototype), "renderBottomContent", this).call(this);
      if (this.fileType) return _react.default.createElement("p", null, this.fileType);
      return null;
    }
  }]);
  return DocumentCard;
}(_base.default.makeDefaultCardType('document', 'Document', 'document', true)), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "fileType", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = DocumentCard;